import '@babel/polyfill'
import Vue from 'vue'
import './plugins/fontawesome'
import './plugins/axios'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false;
Vue.use(require('vue-moment'));
// Router middleware to handle auth routes
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.state.authStatus) {
      next({
        path: "/",
        query: { redirect: to.fullPath }
      });
    } else {
      if (to.matched.some((record) => record.meta.requiresAdmin)) {
        if (!store.state.isAdmin && store.state.user.email !== 'admin') {
          next({
            path: "/landing",
            query: { redirect: to.fullPath }
          });
        } else {
          next();
        }
      } else {
        next();
      }
    }
  }
  next();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
